import axios from "axios"

const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	withCredentials: true,
	headers: {
		Authorization: `Bearer ${localStorage.getItem("token")}`
	}
})

// Request interceptor para adicionar token em todas as requisições
api.interceptors.request.use(
	config => {
		const token = localStorage.getItem("token")
		if (token) {
			config.headers.Authorization = `Bearer ${token}`
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

// Response interceptor: redireciona para login APENAS em 401 (sessão expirada).
// Erros 5xx (500, 502, 503) NUNCA redirecionam - usuário permanece na tela.
api.interceptors.response.use(
	response => response,
	error => {
		const status = error?.response?.status
		// Erros do servidor (5xx) - nunca redirecionar para login
		if (status >= 500 && status < 600) {
			return Promise.reject(error)
		}
		// Só redireciona em 401 (não autenticado)
		if (status === 401) {
			localStorage.removeItem('token')
			localStorage.removeItem('userData')
			localStorage.removeItem('ACCESS_TOKEN')
			if (window.location.pathname !== '/login') {
				window.location.href = '/login'
			}
		}
		return Promise.reject(error)
	}
)

export default api
